import React from 'react';
import { AlertCircleIcon } from 'lucide-react';
interface FieldProps {
  id: string;
  label: string;
  required?: boolean;
  hint?: string;
  error?: string;
  className?: string;
  children: React.ReactNode;
}
export function Field({
  id,
  label,
  required,
  hint,
  error,
  className = '',
  children
}: FieldProps) {
  return <div className={className} data-id="element-75" data-mp="2jgwnyl9l5oo2">
      <label htmlFor={id} className="mb-1.5 flex items-center gap-1 text-xs font-medium text-ink-500" data-id="element-76" data-mp="1vqk8mpc0gpng">
        {label}
        {required && <span className="text-red-500" aria-hidden="true" data-id="element-77" data-mp="1qtakdd0cyk17">
            *
          </span>}
        {required && <span className="sr-only" data-id="element-78" data-mp="24kytd7fb8sdy">(required)</span>}
      </label>
      {children}
      {error ? <p id={`${id}-error`} role="alert" className="mt-1.5 flex items-start gap-1 text-xs font-medium text-red-600" data-id="element-79" data-mp="1zqb599o7xzzw">
          <AlertCircleIcon className="mt-px h-3.5 w-3.5 shrink-0" data-id="element-80" data-mp="1806orm3kxx3y" />
          {error}
        </p> : hint ? <p id={`${id}-hint`} className="mt-1.5 text-xs text-ink-400" data-id="element-81" data-mp="v5zm67gvngc2">
          {hint}
        </p> : null}
    </div>;
}
export const inputBase = 'w-full rounded-md border bg-white px-3 py-2 text-sm text-ink-900 shadow-card transition placeholder:text-ink-300 focus:outline-none focus:ring-4 disabled:bg-ink-50';
export function inputClasses(hasError?: boolean, extra = ''): string {
  return [inputBase, hasError ? 'border-red-400 focus:border-red-500 focus:ring-red-100' : 'border-ink-200 hover:border-ink-300 focus:border-brand-500 focus:ring-brand-100', extra].join(' ');
}